import React from "react";
import { get } from "lodash";
import Divider from "material-ui/Divider";
import { Flex, Box, Text, Image } from "rebass";
import NumberFormat from "react-number-format";
import Currency from "../productcard/Currency";
const DefaultImage =
  "https://s3-ap-southeast-1.amazonaws.com/ola2-cms-staging/assets/1/content/ImageView-image-mobile-cLa.png";

const getPhoto = (product) => {
  let image = DefaultImage;
  if (
    product.photos &&
    product.photos["*"] &&
    product.photos["*"].photos.length > 0
  ) {
    image = product.photos["*"].photos[0];
  } else if (
    product.photos &&
    product.photos["photo_set"] &&
    Object.keys(product.photos["photo_set"]).length > 0
  ) {
    const values = product.photos["photo_set"];
    const key = Object.keys(values)[0];
    image =
      values[key].photos.length > 0 ? values[key].photos[0] : DefaultImage;
  }
  return image;
};

const ListProducts = (props) => {
  const { values, list } = props;
  const header = get(values, "header", "");
  const aligHeader = get(values, "alignHeader", "center");
  //   const list = get(values, "list", []);
  const showDiscount = get(values, "showDiscount", false);
  const showPrice = get(values, "showPrice", false);
  const columnDesktop = get(values, "columnDesktop", 2);
  return (
    <Box width={[1]}>
      <Flex width={[1]} style={{ justifyContent: aligHeader }}>
        <Text fontSize={[2, 3]} p={[2]} style={{ color: "#00BFFF" }}>
          {header}
        </Text>
      </Flex>
      <Divider />
      <Box width={[1]}>
        <Flex width={[1]} style={{ display: "flex", flexWrap: "wrap" }}>
          {list &&
            list.length > 0 &&
            list.map((item, index) => {
              const imageUrl = getPhoto(item);
              const title = get(item, "name", "");
              const price = get(item, "price", 0);
              const discount = get(item, "discount", "");
              let discountValue = discount * 100;
              if (discount > 1) {
                // discountValue = price / discount;
                discountValue = (discount / price) * 100;
              }
              const discountedPrice =
                discount < 1 ? price * (1 - discount) : price - discount;
              const titleDiscount = get(item, "titleDiscount", "");
              return (
                <Box width={[1, 1 / columnDesktop]} key={index} p={[1]}>
                  <Flex
                    width={[1]}
                    style={{ border: "1px solid #c4c4c4" }}
                    p={[2]}
                  >
                    <Box width={["80px", "180px"]}>
                      <Image src={imageUrl} />
                    </Box>
                    <Box width={[1]} p={[2]} pt={[0]}>
                      <Text fontSize={[2, 3]}>{title}</Text>
                      <Flex
                        width={[1]}
                        style={{
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "stretch",
                          display: "flex",
                        }}
                      >
                        <Flex
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Text style={{ color: "#00BFFF" }}>
                            {titleDiscount}
                          </Text>
                        </Flex>
                        <Flex
                          width={[1]}
                          style={{
                            flex: 1,
                            flexDirection: "row",
                            alignItems: "stretch",
                            display: "flex",
                          }}
                        >
                          {showPrice && (
                            <Flex
                              pr={[3]}
                              style={{
                                flexDirection: "column",
                                justifyContent: "center",
                                display: "flex",
                              }}
                            >
                              {discount > 0 && (
                                <Text
                                  fontSize={[1]}
                                  style={{ textDecoration: "line-through" }}
                                >
                                  <Currency value={price} />
                                </Text>
                              )}
                              <Text fontSize={[1]} color={"#00BFFF"}>
                                <Currency value={discountedPrice} />
                              </Text>
                            </Flex>
                          )}
                          {showDiscount && (
                            <Box
                              p={[1]}
                              m={[1]}
                              style={{
                                height: 40,
                                width: 40,
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                                backgroundColor: "#FF3B3B",
                                borderRadius: 99999,
                              }}
                            >
                              <Text fontSize={["10px"]} color={"white"}>
                                <NumberFormat
                                  displayType="text"
                                  decimalSeparator={","}
                                  decimalPrecision={
                                    discountValue % 1 !== 0 ? 2 : 0
                                  }
                                  suffix={"%"}
                                  value={discountValue}
                                />
                              </Text>
                            </Box>
                          )}
                        </Flex>
                      </Flex>
                    </Box>
                  </Flex>
                </Box>
              );
            })}
        </Flex>
      </Box>
    </Box>
  );
};

export default ListProducts;



// WEBPACK FOOTER //
// ./src/editor/components/dealgroup/ListProducts.js